module.exports = __webpack_public_path__ + "img/funk.494e2626.jpg";